
import { SaleConfigStock, SaleStockConfigQtyComesFromField } from "@/models/dossier-configs/sale-config-stock";
import AppStockLocationSelect from "@/components/StockLocationSelect.vue";
import Vue from "vue";
import AppConditionsEdit from "@/components/models/ConditionsEdit.vue";
import { ISelectItem } from "winfakt-vue-components";
import { getSaleRowConditionPropSelectGroup } from "@/utils/prop-select/sale-row-to-condition-prop-group";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";

export default Vue.extend({
	data(){
		return {
			toEditConf: new SaleConfigStock()
		};
	},
	props: {
		value: {
			type: Object as()=>SaleConfigStock,
			required: true
		}
	},
	computed: {
		qtyComesFromFieldItems():ISelectItem<SaleStockConfigQtyComesFromField>[]{
			return [
				{
					text: this.$ct("models.friendlyNames.SaleRow.Amount"),
					value: SaleStockConfigQtyComesFromField.QTY
				},
				{
					text: this.$ct("models.friendlyNames.SaleRow.Delivered"),
					value: SaleStockConfigQtyComesFromField.DELIVERED
				},
				{
					text: this.$ct("models.friendlyNames.SaleRow.Backorder"),
					value: SaleStockConfigQtyComesFromField.BACKORDER
				}
			];
		},
		conditionProps():PropSelectGroup{
			return getSaleRowConditionPropSelectGroup();
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.toEditConf = new SaleConfigStock(this.value.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		cancel(){
			this.close();
		},
		submit(){
			this.$emit("input", this.toEditConf);
			this.close();
		}
	},
	components: {
		AppStockLocationSelect,
		AppConditionsEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
